import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import AssetsList from '../../common/AssetsList';
import SectionState from '../../common/SectionState';
import IndentIntro from './IndentIntro';
import PlainIntro from './PlainIntro';
import { default as SmallIntroComponent } from './SmallIntro';
import { IntroContainer } from './styles';
import { useComponent } from '../../../hooks/useComponent';
const Intro = ({ entryId, componentType, nested, }) => {
    var _a, _b;
    const theme = useTheme();
    const intro = useComponent(entryId, componentType);
    const { componentStyle } = (_a = intro === null || intro === void 0 ? void 0 : intro.fields) !== null && _a !== void 0 ? _a : {};
    const [IntroComponent, textAlign, direction, assetDirection] = useMemo(() => {
        switch (componentStyle) {
            case 'Left Aligned':
                return [PlainIntro, 'left', 'column', 'row'];
            case 'Center Aligned':
                return [PlainIntro, 'center', 'column', 'column'];
            case 'Right Aligned':
                return [PlainIntro, 'right', 'column', 'row-reverse'];
            case 'Horizontal':
                return [PlainIntro, 'left', 'row', 'column'];
            case 'Small':
                return [SmallIntroComponent, 'left', 'column', 'row-reverse'];
            default:
                return [IndentIntro, 'left', 'column', 'row-reverse'];
        }
    }, [componentStyle]);
    const containerProps = useMemo(() => {
        const containerProps = {
            cap: theme.caps.normal,
            styles: {
                container: {
                    height: 'fit-content',
                },
                content: {
                    display: 'flex',
                    flexDirection: assetDirection,
                    gap: theme.spacing.md,
                    alignItems: 'center',
                    height: 'fit-content',
                },
            },
            md: {
                styles: {
                    container: {
                        height: 'fit-content',
                        maxHeight: 'fit-content',
                    },
                    content: {
                        gap: theme.spacing.lg,
                        flexDirection: 'column',
                        alignItems: 'center',
                    },
                },
            },
        };
        return containerProps;
    }, [assetDirection, theme]);
    const assets = useMemo(() => {
        var _a, _b;
        if (!((_a = intro === null || intro === void 0 ? void 0 : intro.fields) === null || _a === void 0 ? void 0 : _a.image))
            return [];
        const asset = {
            fields: {
                image: (_b = intro === null || intro === void 0 ? void 0 : intro.fields) === null || _b === void 0 ? void 0 : _b.image,
                backgroundColor: 'yellow_1',
                type: 'Image Only',
            },
            sys: {
                id: '1',
                contentType: {
                    sys: {
                        id: 'asset',
                    },
                },
            },
            contentTypeId: '',
        };
        return [asset];
    }, [(_b = intro === null || intro === void 0 ? void 0 : intro.fields) === null || _b === void 0 ? void 0 : _b.image]);
    return (_jsx(SectionState, { children: _jsxs(IntroContainer, Object.assign({}, containerProps, { removeContainer: nested, children: [assets.length > 0 && (_jsx(AssetsList, { assets: assets, disposition: "Horizontal", width: 100, height: 100 })), _jsx(IntroComponent, Object.assign({}, intro === null || intro === void 0 ? void 0 : intro.fields, { textAlign: textAlign, direction: direction }))] })) }));
};
export default Intro;
